import { urlHome } from '@/urls';
import { Outlet, ScrollRestoration } from 'react-router';
import { Toaster } from 'sonner';
import { NavigationProgress } from '@repo/ui/components/navigation-progress';
import { useRevalidateOnVisible } from '@repo/ui/hooks/use-revalidate-on-visible';

function CommonLayout() {
  useRevalidateOnVisible();

  return (
    <>
      <ScrollRestoration />
      <NavigationProgress />
      <Toaster />
      <Outlet />
    </>
  );
}

export const route = {
  path: urlHome(),
  element: <CommonLayout />,
};
